// extracted by mini-css-extract-plugin
export default {"icon":"ClipboardButton_icon__vzS4k","copied":"ClipboardButton_copied__d3uYk","keyframes_clipboardbutton":"ClipboardButton_keyframes_clipboardbutton__vmRP-"};